import { Injectable, computed, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AziendaService } from '../azienda/azienda.service';
import { LicenzeService, PacchettoUtenza } from '../licenze/licenze.service';

@Injectable({
  providedIn: 'root',
})
export class UtenteIncaricatoService {
  // 1. Dependency Injection dei serivizi
  private readonly aziendaService = inject(AziendaService);
  private readonly licenzeService = inject(LicenzeService);

  // 2. Trasformo l'Observable dell'azienda in un Signal
  private readonly aziendaCorrente = toSignal(this.aziendaService.aziendaCorrente);

  // 3. Signal per lo stato interno della licenza
  private readonly _licenza = signal<PacchettoUtenza | undefined>(undefined);

  // Expose come readonly signal
  public readonly licenzaUtenteIncaricato = this._licenza.asReadonly();

  // 4. Computed signal per la logica derivata
  public readonly isIntegrazioneIA = computed(
    () => this.licenzaUtenteIncaricato()?.integrazioneIA ?? false,
  );

  constructor() {
    // 5. Reattività dichiarativa con effect()
    // Si attiva automaticamente ogni volta che 'aziendaCorrente' cambia
    effect(() => {
      const azienda = this.aziendaCorrente();
      if (azienda?.id) {
        this.fetchLicenzaUtenteIncaricato(azienda.id);
      }
    });
  }

  private fetchLicenzaUtenteIncaricato(idAzienda: string): void {
    this.licenzeService.getLicenzaUtenteIncaricato(idAzienda).subscribe({
      next: (esito) => {
        this._licenza.set(esito);
      },
      error: (err) => {
        console.error('Errore nel recupero licenza:', err);
        this._licenza.set(undefined);
      },
    });
  }
}
